import React, { Component } from 'react'

import styled from 'styled-components'

import { Icons } from '@stacc/flow-ui-components'
import { FontStyles, Colors } from '@stacc/flow-ui-components'
import { SecondaryButton } from '@stacc/flow-ui-components'
import { RemovedEsignTaskProps } from '../../types/common/common'

const TaskContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px;
  ${FontStyles.LargeStrong};
`

const TaskDescription = styled.div`
  display: flex;
  align-items: center;
  min-height: 35px;

  p {
    margin: 0;
    padding-left: 20px;
  }
`

const ESignButton = styled(SecondaryButton)`
  color: ${Colors.Ferrari};
  border: 2px solid ${Colors.FerrariLight};
  &:hover {
    border: 2px solid ${Colors.FerrariLight};
  }
`

const RemovedEsignTask = ({ title, actionTitle }: RemovedEsignTaskProps) => {
  return (
    <div>
      <TaskContainer>
        <TaskDescription>
          <Icons.AbortedCircle />
          <p>{title}</p>
        </TaskDescription>
        <ESignButton disabled>{actionTitle}</ESignButton>
      </TaskContainer>
    </div>
  )
}

export default RemovedEsignTask
